export default {
  default: () => import("/app/apps/client/layouts/default.vue").then(m => m.default || m)
}